var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecipeMania(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0234 116.734V121.922H30.6797V124.57C32.1328 124.555 33.5156 124.492 35.1172 124.203L35.2578 125.625C33.3594 125.977 31.7656 126.008 29.9922 126.016H29.0078V120.547H32.3516V118.125H28.9922V116.734H34.0234ZM34.6484 121.594V120.172H36.1953V115.562H37.8359V128.672H36.1953V121.594H34.6484ZM39.0859 129.391V115.266H40.7422V129.391H39.0859ZM47.7578 118.656C47.7422 121.25 49.1094 123.844 51.3984 124.828L50.3672 126.219C48.7422 125.469 47.5547 123.977 46.8984 122.133C46.25 124.117 45.0312 125.742 43.3203 126.547L42.2578 125.094C44.6094 124.078 45.9844 121.383 45.9922 118.656V116.406H47.7578V118.656ZM52.4141 129.406V115.266H54.1641V129.406H52.4141ZM68.0391 115.266V129.391H66.2891V115.266H68.0391ZM56.2109 124.625C56.7578 124.625 57.3438 124.617 57.9609 124.609V118.062H56.5859V116.641H64.6016V118.062H63.2422V124.398C63.9141 124.344 64.5859 124.281 65.2266 124.203L65.3203 125.5C62.2891 125.992 58.9844 126.047 56.3828 126.047L56.2109 124.625ZM59.6328 124.578C60.2578 124.562 60.8984 124.539 61.5391 124.5V118.062H59.6328V124.578ZM81.0547 116.641V125.891H74.3672V116.641H81.0547ZM76.0703 124.5H79.3203V118H76.0703V124.5ZM83.1953 129.391V115.266H84.9297V120.688H87.1016V122.156H84.9297V129.391H83.1953ZM99.4766 115.266V129.391H97.7578V115.266H99.4766ZM88.5078 125.844V116.641H90.2266V124.359C92.2031 124.328 94.3125 124.156 96.4922 123.719L96.7109 125.172C94.2266 125.688 91.9219 125.852 89.7266 125.844H88.5078ZM105.32 116.297C107.445 116.297 108.977 118.234 108.992 121.281C108.977 124.352 107.445 126.281 105.32 126.281C103.172 126.281 101.641 124.352 101.648 121.281C101.641 118.234 103.172 116.297 105.32 116.297ZM103.32 121.281C103.312 123.453 104.133 124.711 105.32 124.719C106.516 124.711 107.312 123.453 107.32 121.281C107.312 119.125 106.516 117.859 105.32 117.859C104.133 117.859 103.312 119.125 103.32 121.281ZM110.852 129.391V115.266H112.586V120.688H114.758V122.156H112.586V129.391H110.852Z",
    fill: "#242424"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_5273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.02 49.0005C119.02 75.5258 97.5258 97.0205 71.0005 97.0205C44.4751 97.0205 22.9805 75.5258 22.9805 49.0005C22.9805 22.4751 44.4751 0.980469 71.0005 0.980469C97.5258 0.980469 119.02 22.4751 119.02 49.0005Z",
    fill: "url(#paint0_linear_1275_5273)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1275_5273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.1758 71.343H50.0612C49.5712 71.343 49.1465 70.951 49.1465 70.4283C49.1465 69.9057 49.5385 69.5137 50.0612 69.5137H90.1758C90.6658 69.5137 91.0905 69.9057 91.0905 70.4283C91.0905 70.951 90.6985 71.343 90.1758 71.343Z",
    fill: "#FFC25D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0371 29.9874L86.8758 24.8261C85.7978 23.7481 84.0664 23.7481 83.0211 24.8261L79.7871 28.0601L81.0611 29.3341L87.4964 35.7694L88.7704 37.0434L92.0044 33.8094C93.1151 32.7967 93.1151 31.0654 92.0371 29.9874Z",
    fill: "#FFC25D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2563 37.0765L79.821 30.6412L78.547 29.3672L53.3936 54.5205L53.361 54.5532C53.2956 54.6185 53.263 54.6839 53.1976 54.7819C53.1976 54.8145 53.165 54.8145 53.165 54.8472C53.165 54.8472 53.165 54.8799 53.1323 54.8799L49.2776 66.4765C49.1796 66.8032 49.245 67.1625 49.5063 67.4239C49.6696 67.5872 49.931 67.6852 50.1596 67.6852C50.2576 67.6852 50.3556 67.6525 50.4536 67.6525L62.0503 63.7979C62.083 63.7979 62.083 63.7652 62.083 63.7652C62.1156 63.7652 62.1156 63.7325 62.1483 63.7325C62.2463 63.6999 62.3116 63.6345 62.377 63.5692L62.4096 63.5365L87.563 38.3832L86.2563 37.0765ZM54.243 64.3859L52.479 62.6219L54.4063 56.8072L60.0576 62.4585L54.243 64.3859Z",
    fill: "#FFC25D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1275_5273)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70.9999,
    cy: 49.0009,
    r: 42.4906,
    stroke: "#FFC25D",
    strokeWidth: 2.56553
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1275_5273",
    x: 49.1465,
    y: 24.0176,
    width: 43.6953,
    height: 48.3514,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1275_5273",
    x: 27.2266,
    y: 5.22754,
    width: 87.5469,
    height: 88.5731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5273"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_5273",
    x1: 37.6805,
    y1: 11.4338,
    x2: 107.75,
    y2: 79.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD2C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_5273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white",
    transform: "translate(22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipeMania);
export default __webpack_public_path__ + "static/media/RecipeMania.fad466ae9c961aa98b3bfe5d34e2e601.svg";
export { ForwardRef as ReactComponent };